import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../response/ErrorResponse";
import { DeleteRolesFormData } from "../schema/DeleteRolesSchema";
import { DeleteRoleResponseSchema } from "../response/DeleteResponse";

export const useDeleteRole = () => {
    return useMutation({
        mutationKey: ['role', 'delete'],
        mutationFn: async (formData: DeleteRolesFormData) => privateApi.delete(`/v4/role/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteRoleResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid role data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid role data format");
            } else {
                console.error(`Failed to delete permission`, error);
                throw error;
            }
        }
    })
}